import { gql } from '@apollo/client';

export const RdTaxCreditContributorFragment = gql`
  fragment RdTaxCreditContributor on RdTaxCreditContributor {
    id
    canonicalName
    canonicalEmail
    rdTaxCreditId
  }
`;
